import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable, throwError as observableThrowError} from 'rxjs';
import {CommonService} from '../../theme/pages/home/_services';
import {Injectable} from '@angular/core';
import {HelperService, StorageService} from '../../_shared/services';
import {environment} from '../../../environments/environment';

@Injectable()
export class AuthenticationService {
    constructor(
        private http: HttpClient,
        private helper: HelperService,
        private storage: StorageService,
        private commonRest: CommonService,
    ) {}

    login(username: string, password: string): Observable<boolean> {
        const options = {
            headers: new HttpHeaders({
                authorization: 'Basic ' + environment.AUTHPASS,
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
        };
        return this.http
            .post(
                this.helper.getAuthUrl(),
                'username=' +  encodeURIComponent(username.trim()) + '&password=' +  encodeURIComponent(password) + '&grant_type=password',
                options,
            )
            .pipe(
                map((token) => {
                    this.storage.saveToken(token);
                    return true;
                }),
                catchError((e: any) => {
                    // this.commonRest.sendWarning(
                    //     'Napaka pri prijavi - *' + username + '* production:' + environment.production,
                    //     e,
                    //     'AuthenticationService',
                    // );
                    console.error('Napaka pri: AuthenticationService');
                    return observableThrowError(e);
                }),
            );
    }

    logout() {
        this.storage.clearToken();
        this.storage.deleteAll();
        this.storage.deleteUserData();
        this.storage.deleteAppData();
        this.storage.deleteContractorSettings();
    }
}
